import VideoRecorder from '../VideoRecorder'
import styled from 'styled-components'
import { Student } from '../../libs/student-service'
import { Class } from '../../libs/login-service'
import { Batch } from '../../libs/batch-service'
import { useEffect, useState } from 'react'

const Header = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e5e6eb;
`

const HeaderContent = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
`

const SelectWrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`

const SelectLabel = styled.label`
    font-size: 14px;
    font-weight: 600;
    color: #333;
`

const SelectDropdown = styled.select`
    padding: 8px 12px;
    border: 1px solid #e5e6eb;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    background-color: #ffffff;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        border-color: #31c690;
    }

    &:focus {
        outline: none;
        border-color: #31c690;
        box-shadow: 0 0 0 2px rgba(49, 198, 144, 0.1);
    }
`

const AssessmentPanel = styled.div`
    display: flex;
    width: 100%;
    min-height: calc(100vh - 400px);
    max-height: calc(100vh - 150px);
`

const VideoWrapper = styled.div`
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
    gap: 15px;
    background-color: #fafafa;
`

const PannelWrapper = styled.div`
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 0;
    overflow: hidden;
`

const SelectedStudentInfo = styled.div`
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    border-bottom: 1px solid #e5e6eb;
`

const StudentName = styled.div`
    font-size: 24px;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
    gap: 10px;
`

const StudentStatus = styled.span`
    background-color: #e8f5f0;
    color: #31c690;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
`

const StudentID = styled.div`
    font-size: 14px;
    color: #999;
    margin-top: 8px;
`

const ProgressBar = styled.div`
    width: 100%;
    height: 8px;
    background-color: #e5e6eb;
    border-radius: 4px;
    margin-top: 12px;
    overflow: hidden;
`

const ProgressFill = styled.div`
    height: 100%;
    background-color: #31c690;
    border-radius: 4px;
`

const Table = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
`

const TableHeader = styled.div`
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr;
    gap: 20px;
    padding: 15px 10px;
    background-color: #f5f5f5;
    font-weight: 600;
    border-bottom: 1px solid #e5e6eb;
    font-size: 14px;
    color: #333;
`

const TableRow = styled.div<{ selected?: boolean }>`
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr;
    gap: 20px;
    padding: 15px 10px;
    border-bottom: 1px solid #f0f0f0;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
    background-color: ${(props) =>
        props.selected ? '#f0f8f5' : 'transparent'};
    transition: background-color 0.2s;

    &:hover {
        background-color: #fafafa;
    }
`

const AllocateButton = styled.button`
    background-color: #31c690;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    width: fit-content;

    &:hover {
        background-color: #2aad7a;
    }
`

const SkillButton = styled.div<{ active: boolean }>`
    padding: 10px 15px;
    &:hover {
        cursor: pointer;
    }
    border-bottom: 3px solid
        ${(props) => (props.active ? '#31c690' : 'transparent')};
`
interface AssessmentContentProps {
    students: Student[]
    classes: Class[]
    selectedClass: Class | undefined
    batch: Batch | undefined
    onClassChange: (classId: number) => void
    onBatchChange: (batchId: number) => void
    status:
        | 'start'
        | 'confirm'
        | 'uploading'
        | 'completed'
        | 'error'
        | 'default'
    handleSubmitClick: (
        mediaBlobUrl: string | null,
        selectedSkill?: string
    ) => void
    badgeSelectedSkill?: string
    selectedStudent: Student | null
    onStudentChange: (student: Student) => void
}
const data = [
    {
        title: 'Jump',
    },
    {
        title: 'Skip',
    },
    {
        title: 'Hop',
    },
    {
        title: 'Sidestep',
    },
    {
        title: 'Kick',
    },
    {
        title: 'Throw',
    },
    {
        title: 'Catch',
    },
]

const ButtonGroup = styled.div`
    display: flex;
    gap: 20px;
    padding-left: 70px;
`

const getStudentProgress = (student: Student): number => {
    // Return the number of assessments the student has completed
    return (
        (student as any).assessments.filter(
            (assessment: any) => assessment.result !== 'error'
        ).length || 0
    )
}

export default function AssessmentContent({
    students,
    classes,
    selectedClass,
    batch,
    onClassChange,
    onBatchChange,
    status,
    handleSubmitClick,
    badgeSelectedSkill,
    selectedStudent,
    onStudentChange,
}: AssessmentContentProps) {
    const [showData, setShowData] = useState(data[0])

    // Update showData when badgeSelectedSkill changes
    useEffect(() => {
        if (badgeSelectedSkill) {
            const skillData = data.find(
                (item) => item.title === badgeSelectedSkill
            )
            if (skillData) {
                setShowData(skillData)
            }
        }
    }, [badgeSelectedSkill])

    const currentSkillIndex = data.findIndex(
        (skill) => skill.title === showData.title
    )

    const handlePreviousSkill = () => {
        if (currentSkillIndex > 0) {
            setShowData(data[currentSkillIndex - 1])
        }
    }

    const handleNextSkill = () => {
        if (currentSkillIndex < data.length - 1) {
            setShowData(data[currentSkillIndex + 1])
        }
    }

    const progress = selectedStudent ? getStudentProgress(selectedStudent) : 0
    const totalSkills = 7

    return (
        <>
            <Header>
                <div>Assessment Panel | Assess students' movemonet skills</div>
                <HeaderContent>
                    <SelectWrapper>
                        <SelectLabel>Class:</SelectLabel>
                        <SelectDropdown
                            value={selectedClass?.id || ''}
                            onChange={(e) =>
                                onClassChange(Number(e.target.value))
                            }
                        >
                            {classes.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.name}
                                </option>
                            ))}
                        </SelectDropdown>
                    </SelectWrapper>
                    <SelectWrapper>
                        <SelectLabel>Batch:</SelectLabel>
                        <SelectDropdown
                            value={batch?.id || ''}
                            onChange={(e) =>
                                onBatchChange(Number(e.target.value))
                            }
                        >
                            {selectedClass?.batches.map((b) => (
                                <option key={b.id} value={b.id}>
                                    {b.name}
                                </option>
                            ))}
                        </SelectDropdown>
                    </SelectWrapper>
                </HeaderContent>
            </Header>
            <AssessmentPanel>
                <VideoWrapper>
                    <ButtonGroup>
                        {data.map((item, i) => (
                            <SkillButton
                                key={i}
                                onClick={() => setShowData(item)}
                                active={showData.title === item.title}
                            >
                                {item.title}
                            </SkillButton>
                        ))}
                    </ButtonGroup>
                    <ButtonGroup>{showData.title}</ButtonGroup>
                    <VideoRecorder
                        handleSubmit={handleSubmitClick}
                        assessmentStatus={status}
                        selectedSkill={showData.title}
                        onPreviousSkill={handlePreviousSkill}
                        onNextSkill={handleNextSkill}
                    />
                </VideoWrapper>
                <PannelWrapper>
                    {selectedStudent && (
                        <SelectedStudentInfo>
                            <StudentName>
                                {selectedStudent.first_name}{' '}
                                {selectedStudent.last_name}
                                <StudentStatus>Assessing</StudentStatus>
                            </StudentName>
                            <StudentID>
                                Student ID: {selectedStudent.student_id}
                            </StudentID>
                            <ProgressBar>
                                <ProgressFill
                                    style={{
                                        width: `${(progress / totalSkills) * 100}%`,
                                    }}
                                />
                            </ProgressBar>
                            <div
                                style={{
                                    marginTop: '8px',
                                    fontSize: '12px',
                                    color: '#999',
                                }}
                            >
                                {progress}/{totalSkills} Completed
                            </div>
                        </SelectedStudentInfo>
                    )}
                    <Table>
                        <TableHeader>
                            <div>Name</div>
                            <div>Progress</div>
                            <div>Allocate</div>
                        </TableHeader>
                        {students.map((s, index) => (
                            <TableRow
                                key={index}
                                selected={selectedStudent?.id === s.id}
                                onClick={() => onStudentChange(s)}
                            >
                                <div>
                                    {s.first_name} {s.last_name}
                                </div>
                                <div>
                                    {getStudentProgress(s)}/{totalSkills}
                                </div>
                                <div>
                                    <AllocateButton>Start</AllocateButton>
                                </div>
                            </TableRow>
                        ))}
                    </Table>
                </PannelWrapper>
            </AssessmentPanel>
        </>
    )
}
